export const doughnutOptions = {
  maintainAspectRatio: false,
  cutoutPercentage: 70,
  legend: {
    display: true,
    labels: {
      boxWidth: 10
    }
  },
  plugins: {
    datalabels: {
      color: "black",
      font: {
        size: 12
      }
    }
  }
};

export const horizontalBar = {
  scales: {
    xAxes: [
      {
        stacked: true
      }
    ],
    yAxes: [
      {
        stacked: true
      }
    ]
  },
  maintainAspectRatio: false,
  legend: {
    display: true,
    labels: {
      boxWidth: 10
    }
  },
  tooltips: {
    enabled: true,
    mode: "label",
    backgroundColor: "black",
    filter: function(item, data) {
      data = data.datasets[item.datasetIndex].data[item.index];
      return !isNaN(data) && data !== 0 && data !== null;
    }
  },
  plugins: {
    datalabels: {
      color: "black"
    }
  }
};

export const verticalBar = {
  scales: {
    xAxes: [
      {
        stacked: true
      }
    ],
    yAxes: [
      {
        stacked: true
      }
    ]
  },
  maintainAspectRatio: false,
  legend: {
    display: true,
    labels: {
      boxWidth: 10
    }
  },
  tooltips: {
    enabled: true,
    mode: "label",
    backgroundColor: "black",
    filter: function(item, data) {
      data = data.datasets[item.datasetIndex].data[item.index];
      return !isNaN(data) && data !== 0 && data !== null;
    }
  },
  plugins: {
    datalabels: {
      color: "black"
    }
  }
};

export const lineOptions = {
  maintainAspectRatio: false,
  legend: {
    display: false,
    labels: {
      boxWidth: 10
    }
  },
  plugins: {
    datalabels: {
      color: "black",
      display: function(context) {
        return context.dataset.data[context.dataIndex] !== 0; // or >= 1 or ...
      }
    }
  }
};
